export default __webpack_public_path__ + "static/media/wr.90341240.svg";